export default "icons-cart"